/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./publishVideo.defs.js";
export { main as default } from "./publishVideo.defs.js";
